const English = {

  "Yesterday with": "Yesterday with",
  'and': 'and',
  'concert in LA. Was  totally fantastic! People were really excited about  this one!': 'concert in LA. Was  totally fantastic! People were really excited about  this one!',
  '#MotivationMonday': '#MotivationMonday',
  '#Morning': '#Morning',
  "Reference site about Lorem Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.": '132242342342342792877Reference site about Lorem Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.Reference site about Lorem  Ipsum, giving information on its origins, as well as  a random Lipsum generator.',
  "Announcements": "Announcements",
  "Featured Posts": "Featured Posts",
  "Action Required": "Action Required",
  "more liked this": "more liked this",
  "Comments": "Comments",
  "Awards": "Awards",
  "Upcoming Birthdays": "Upcoming Birthdays",
  "Upcoming Work-Anniversaries": "Upcoming Work-Anniversaries",
  "Popular Posts": "Popular Posts",
  "Upcoming Wedding Anniversaries": "Upcoming Wedding Anniversaries",
  "Reference site about lorem ipsum, giving information": "Reference site about lorem ipsum, giving information",
  "Follow Up Suggestions": "Follow Up Suggestions",
  "Feed": "Feed",
  "Post": "Post",
  "My Feeds": "My Feeds",
  "Feed Detail": "Feed Detail",
  "Featured": "Featured",
  "Pop. Posts": "Pop. Posts",
  "Apply": "Apply",
  "Team Leaves": "Team Leaves",
  "My Leaves": "My Leaves",
  "Hello": "Hello",
  "Leave Ledger": "Leave Ledger",
  "Org Leaves": "Org Leaves",
  "Employees": "Employees",
  "All Teams": "All Teams",
  "My Team": "My Team",
  "Log Out": "Log Out",
  "Awards": "Awards",
  "Quick Actions": "Quick Actions",
  "Ticket Management": "Ticket Management",
  "Ticket Detail": "Ticket Detail",
  "My Tickets": "My Tickets",
  "Add Ticket": "Add Ticket",
  "Ticket Detail": "Ticket Detail",
  "Leave": "Leave",
  "Apply": "Apply",
  "My Leaves": "My Leaves",
  "Team Leaves": "Team Leaves",
  "Org Leaves": "Org Leaves",
  "Leave Ledger": "Leave Ledger",
  "My Leave Completed Leave": "My Leave Completed Leave",
  "Gallery": "Gallery",
  "Single Gallery": "Single Gallery",
  "Add Media": "Add Media",
  "Hr Assessment": "Hr Assessment",
  "My Assessment": "My Assessment",
  "EmployeeAssessment": "EmployeeAssessment",
  "Hr Assessment": "Hr Assessment",
  "Recruitment": "Recruitment",
  "Recruitment Dashboard": "Recruitment Dashboard",
  "Recruitment Details": "Recruitment Details",
  "Create Position": "Create Position",
  "Applicant Details": "Applicant Details",
  "Add Applicant": "Add Applicant",
  "Applicant Search": "Applicant Search",
  "Work From Home": "Work From Home",
  "Work From Home Dashboard": "Work From Home Dashboard",
  "My Work From Home": "My Work From Home",
  "Team Work From Home": "Team Work From Home",
  "Completed": "Completed",
  "Pending": "Pending",
  "More": "More",
  "Communication Panel": "Communication Panel",
  "Create Reminders": "Create Reminders",
  "Reminders": "Reminders",
  "First time dashboard": "First time dashboard",
  "Audit Trails": "Audit Trails",
  "Create Owner Page": "Create Owner Page",
  "Account Owner Page": "Account Owner Page",
  "Change Password": "Change Password",
  "OTP Verification": "OTP Verification",
  "Policy": "Policy",
  "AddPolicy": "AddPolicy",
  "Policies": "Policies",
  "Policydetail": "Policydetail",
  "All Teams": "All Teams",
  "My Teams": "My Teams",
  "New": "New",
  "Self Learning": "Self Learning",
  "Instructor Training": "Instructor Training",
  "Task Management": "Task Management",
  "Task Detail": "Task Detail",
  "Search": "Search",
  "Search Result": "Search Result",
  "What would you like to search": "What would you like to search",
  "Search Employee & their post": "Search Employee & their post",
  "Profile": "Profile",
  "Change password": "Change password",
  "Send Us Feedback": "Send Us Feedback",
  "2022 © OrgGenie - Your Organization Portal. Powered By": "2022 © OrgGenie - Your Organization Portal. Powered By",
  "BizBrolly": "BizBrolly",
  "Version 16.6": "Version 16.6",
  "Log Out": "Log Out",
  "Add App": "Add App",
  "App Title": "App Title",
  "Links": "Links",
  "Existing App": "Existing App",
  "Apps": "Apps",
  "Decline": "Decline",
  "Save": "Save",





};

export default English;
